<template>
  <page :back-to="getPreviousUrl" :title="pageTitle" size="is-desktop">
    <div slot="page-header-right">
      <button
        class="button is-primary"
        @click="save"
      >Add
      </button>
    </div>

    <form @submit.prevent="Save">
      <button ref="submitButton" type="submit" class="is-hidden"></button>

      <div class="columns">
        <div class="column is-8">

          <div class="box">
            <b-field label="Title">
              <b-input v-model="form.title" value="Category"></b-input>
            </b-field>
            <b-field label="Dark Background Color">
              <b-input v-model="form.dark_bgcolor" value="Category"></b-input>
            </b-field>
            <b-field label="Dark Text Color">
              <b-input v-model="form.dark_txtcolor" value="Category"></b-input>
            </b-field>
            <b-field label="Light Background Color">
              <b-input v-model="form.light_bgcolor" value="Category"></b-input>
            </b-field>
            <b-field label="Light Text Color">
              <b-input v-model="form.light_txtcolor" value="Category"></b-input>
            </b-field>
          </div>

        </div>
      </div>
    </form>
  </page>
</template>

<script>
export default {


  props: {
    category: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      form: new window.Form({
        title: null,
        dark_bgcolor: '#000000',
        dark_txtcolor: '#ffffff',
        light_bgcolor: '#000000',
        light_txtcolor: '#ffffff',
      })
    };
  },

  computed: {
    getPreviousUrl() {
      return localStorage.getItem('previous');
    },

    pageTitle() {
      return "Magazine / Category / Create";
    },

  },

  methods: {
    save() {
      this.form.post('/admin/api/magazine/categories/add').then(this.whenCreated);
    },

    whenCreated() {
      this.$buefy.toast.open("Category Added");

      this.$router.push("/magazine/categories");
    },
  },
};
</script>
